module.exports = __webpack_public_path__ + "static/speedVaporV2-988fabb094aae23d7dcccb57954e07ea.jpg";